<template>
  <div class="schedule-template position-relative col-12 p-0 mt-3 d-flex flex-wrap">
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Gallery</label>
      <ThumbnailPreview :values="secondImages" @changeValues="changeThumbnailPreview"></ThumbnailPreview>
      <span class="btn btn-upload btn-outline-success">
        <label for="upload-media" class="m-0 w-100 cursor-pointer">Choose Images</label>
        <input type="file" id="upload-media" @change.stop.prevent="changeUploadImage" multiple />
      </span>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Brand</label>
      <input type="text" class="input textarea overflow-auto form-control" :value="meta.brand" @change.stop.prevent="changeBrand" />
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Description*</label>
      <textarea class="input textarea overflow-auto form-control" :value="description" @change.stop.prevent="changeDescription"></textarea>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Category*</label>
      <Select class="mt-2" :options="taxonomies" :value="meta.taxonomy" @changeValue="changeTaxonomy"></Select>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Size*</label>
      <Select class="mt-2" :options="sizeOptions" :value="sizes" @changeValue="changeSize" multiple taggable></Select>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Colors</label>
      <Select class="mt-2" :options="colors" :value="meta.colors" @changeValue="changeColor" multiple></Select>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="font-weight-bold">Tags</label>
      <Select class="mt-2" :value="meta.tags" @changeValue="changeTag" multiple taggable :maxInputLength="20" :max="3"></Select>
    </div>
    <div class="position-relative form-group col-12 d-flex flex-wrap">
      <label class="w-100 font-weight-bold">New with tags</label>
      <div class="position-relative togglebox-container col-6 p-0">
        <Select class="mt-2" :options="tagAttachedOptions" :value="meta.tag_attached" @changeValue="changeTagAttached"></Select>
        <small>Does this item have tags attached?</small>
      </div>
      <div class="togglebox-container col-6">
        <div class="position-relative mt-2">
          <input type="checkbox" :checked="meta.add_to_shop" @change.stop.prevent="changeAddToShop" />
          <div class="slider"></div>
        </div>
        <small>Add this item to your Boutique?</small>
      </div>
    </div>
    <div class="form-group col-12 d-flex flex-wrap">
      <label class="col-12 p-0 font-weight-bold">Price*</label>
      <div class="position-relative form-group col-6 pl-0">
        <input class="form-control" placeholder="Original" type="number" :value="price.original" @change.stop.prevent="changePriceOriginal" />
      </div>
      <div class="position-relative form-group col-6 pr-0">
        <input class="form-control" placeholder="Listing" type="number" :value="price.listing" @change.stop.prevent="changePriceListing" />
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
export default {
  mixins: [Event],
  components: {
    ThumbnailPreview
  },
  data() {
    return {
      colors: [],
      taxonomies: [],
      tagAttachedOptions: [
        { id: 'no', text: 'No' },
        { id: 'yes', text: 'Yes' }
      ]
    }
  },
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    scheduleId() {
      return this.config?.scheduleId
    },
    submitUri() {
      return `schedule/update/${this.scheduleId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data?.meta || {}
    },
    secondImages() {
      let image = {}
      Object.entries(this.meta.second_img).forEach(([id, object]) => {
        if (_.isObjectLike(object?.files)) {
          image[id] = object
        } else if (_.isString(object).length > 0) {
          image[id] = {
            files: [object]
          }
        }
      })
      return image
    },
    description() {
      return this.$util.data.decode(this.meta.description || '')
    },
    price() {
      return Object.assign(
        {
          original: '',
          listing: ''
        },
        this.meta.price || {}
      )
    },
    sizeOptions() {
      let taxonomyObject = {}
      let customSizes = [...(this.meta.sizes || [])]
      this.taxonomies.forEach((item) => {
        if (item.id == this.meta.taxonomy) {
          taxonomyObject = item
          return false
        }
      })

      let sizes = []
      if (!_.isUndefined(taxonomyObject.size)) {
        Object.values(taxonomyObject.size).forEach((size1) => {
          let tags = size1.tags
          let tagName = size1.name
          for (const [key2, size2] of Object.entries(size1.size_systems)) {
            let country = key2
            Object.values(size2.sizes).forEach((size3) => {
              let text = tagName + ' › ' + country.toUpperCase() + ' › ' + size3.display
              let id = this.$util.data.encode({
                size: size3,
                country: country,
                tags: tags
              })
              sizes.push({
                text: text,
                id: id
              })
              if (customSizes.indexOf(id) != -1) {
                delete customSizes[customSizes.indexOf(id)]
              }
            })
          }
        })
      }

      Object.values(customSizes).forEach(function (size) {
        sizes.push({
          text: size,
          id: size
        })
      })

      return sizes
    },
    sizes() {
      if (this.taxonomies.length > 0) {
        return this.meta.sizes || []
      } else {
        return []
      }
    }
  },
  mounted() {
    this.$emitter.on('Modal.Schedule.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.Schedule.Edit.Submit', this.submit)
  },
  created() {
    this.initTaxonomy()
    this.initColor()
  },
  methods: {
    initTaxonomy() {
      this.$util.get(
        'schedule-template/attribute/taxonomy/poshmark',
        {},
        null,
        {
          done: (response) => {
            Object.values(response.departments).forEach((taxmonomy1) => {
              let sizes = taxmonomy1.size_sets
              if (_.isObjectLike(taxmonomy1.categories) && taxmonomy1.categories.length > 0) {
                Object.values(taxmonomy1.categories).forEach((taxmonomy2) => {
                  if (taxmonomy2.size_sets.length > 0) {
                    sizes = taxmonomy2.size_sets
                  }
                  if (_.isObjectLike(taxmonomy2.category_features) && taxmonomy2.category_features.length > 0) {
                    Object.values(taxmonomy2.category_features).forEach((taxmonomy3) => {
                      if (taxmonomy3.size_sets.length > 0) {
                        sizes = taxmonomy3.size_sets
                      }
                      this.taxonomies.push({
                        id: this.$util.data.encode([
                          {
                            id: taxmonomy1.id,
                            slug: taxmonomy1.slug.toLowerCase(),
                            name: taxmonomy1.display
                          },
                          {
                            id: taxmonomy2.id,
                            slug: taxmonomy2.slug.toLowerCase(),
                            name: taxmonomy2.display
                          },
                          {
                            id: taxmonomy3.id,
                            slug: taxmonomy3.slug.toLowerCase(),
                            name: taxmonomy3.display
                          }
                        ]),
                        text: taxmonomy1.display + ' › ' + taxmonomy2.display + ' › ' + taxmonomy3.display,
                        size: sizes
                      })
                    })
                  } else {
                    this.taxonomies.push({
                      id: this.$util.data.encode([
                        {
                          id: taxmonomy1.id,
                          slug: taxmonomy1.slug.toLowerCase(),
                          name: taxmonomy1.display
                        },
                        {
                          id: taxmonomy2.id,
                          slug: taxmonomy2.slug.toLowerCase(),
                          name: taxmonomy2.display
                        }
                      ]),
                      text: taxmonomy1.display + ' › ' + taxmonomy2.display,
                      size: sizes
                    })
                  }
                })
              } else {
                this.taxonomies.push({
                  id: this.$util.data.encode([
                    {
                      id: taxmonomy1.id,
                      slug: taxmonomy1.slug.toLowerCase(),
                      name: taxmonomy1.display
                    }
                  ]),
                  text: taxmonomy1.display,
                  size: sizes
                })
              }
            })
          }
        },
        {},
        {
          force: true
        }
      )
    },
    initColor() {
      this.$util.get(
        'schedule-template/attribute/color/poshmark',
        {},
        null,
        {
          done: (response) => {
            Object.values(response).forEach((color) => {
              this.colors.push({
                id: color.name,
                text: color.name
              })
            })
          }
        },
        {},
        {
          force: true
        }
      )
    },
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeUploadImage(e) {
      if (!_.isUndefined(e.target.files)) {
        let images = Object.assign([], this.store.getter('meta.second_img', []))
        Object.values(e.target.files).forEach((file) => {
          images.push({
            files: [file]
          })
        })
        this.store.commit('meta.second_img', images)
      }
    },
    changeThumbnailPreview(images) {
      this.store.commit('meta.second_img', images)
    },
    changeBrand(e) {
      this.store.commit('meta.brand', e.target.value)
    },
    changeDescription(e) {
      this.store.commit('meta.description', this.$util.data.encode(e.target.value))
    },
    changeTaxonomy(value) {
      this.store.commit('meta.taxonomy', value)
    },
    changeSize(value) {
      this.store.commit('meta.sizes', value)
    },
    changeColor(value) {
      this.store.commit('meta.colors', value)
    },
    changeTag(value) {
      this.store.commit('meta.tags', value)
    },
    changeTagAttached(value) {
      this.store.commit('meta.tag_attached', value)
    },
    changeAddToShop(e) {
      this.store.commit('meta.add_to_shop', Number(e.target.checked))
    },
    changePriceOriginal(e) {
      this.store.commit('meta.price.original', e.target.value)
    },
    changePriceListing(e) {
      this.store.commit('meta.price.listing', e.target.value)
    },
    submit(data) {
      this.submitForm(data, {
        done: (response) => {
          if (!_.isUndefined(response.zipUrl)) {
            this.downloadZipFile(response.zipUrl)
          }
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
